import React, { useState } from 'react';
import { Grid, Typography, Button } from '@material-ui/core';
import { makeStyles /*useTheme*/ } from '@material-ui/core/styles';
// import useMediaQuery from '@material-ui/core/useMediaQuery';

import populationMap from '../assets/populationMap.png';
import mapLegend from '../assets/Legend.png';
import mapBlack from '../assets/aidsMapBlack.png';
import mapHispanic from '../assets/aidsMapHispanic.png';
import mapWhite from '../assets/aidsMapWite.png';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    backgroundColor: '#1B1212'
  },
  heading: {
    width: '52.7%',
    textAlign: 'center',
    marginTop: '7.5rem',

    [theme.breakpoints.down('md')]: {
      width: '90%',
      marginTop: '2.25rem'
    }
  },
  mapCont: {
    padding: '0 8.5rem',
    [theme.breakpoints.down('md')]: {
      padding: 0
    }
  },
  map: {
    marginTop: '4rem',
    width: '60.5%',
    [theme.breakpoints.down('md')]: {
      width: '90%'
    }
  },
  mapButtons: {
    width: '71.8%',
    maxWidth: '700px',
    marginTop: '2.8rem',
    [theme.breakpoints.down('md')]: {
      width: '85%'
    },
    [theme.breakpoints.down('md')]: {
      width: '85%'
    }
  },
  buttonCont: {
    marginTop: '1rem'
  },

  buttonContained: {
    width: '9.4rem',
    height: '2.5rem',
    borderRadius: 0,
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#fff',
      color: '#000'
    },
    [theme.breakpoints.down('sm')]: {
      ...theme.typography.mobile.button,
      height: '2rem',
      width: '8rem'
    },
    [theme.breakpoints.down('xs')]: {
      ...theme.typography.mobile.button,
      height: '2rem',
      width: '4.25rem'
    }
  },
  buttonOutline: {
    border: '1px solid rgba(250, 250, 250, .6)',
    height: '2.5rem',
    color: 'rgba(250, 250, 250, .6)',
    width: '9.4rem',
    borderRadius: 0,
    [theme.breakpoints.down('sm')]: {
      ...theme.typography.mobile.button,
      height: '2rem',
      width: '8rem'
    },
    [theme.breakpoints.down('xs')]: {
      ...theme.typography.mobile.button,
      height: '2rem',
      width: '4.25rem'
    }
  },
  sourceCont: {
    marginTop: '4rem',
    [theme.breakpoints.down('md')]: {
      marginTop: '2rem'
    }
  },

  legend: {
    width: '55%',
    [theme.breakpoints.down('md')]: {
      width: '90%'
    }
  },
  // ------------------------------------------------------
  filterText: {
    fontFamily: 'NeuePlakR',
    fontSize: '18px',
    color: '#979797',
    lineHeight: '28px',
    letterSpacing: '1px',
    textAlign: 'center'
  },
  source: {
    marginLeft: '2rem',
    marginTop: '4rem',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginTop: '1.3rem'
    }
  },
  caption: {
    ...theme.typography.caption
  },
  body1M: {
    [theme.breakpoints.down('sm')]: {
      ...theme.typography.mobile.body1
    }
  },
  subhead3: {
    ...theme.typography.subhead3
  },
  link: {
    color: '#979797'
  }
}));

const MapStat2 = () => {
  const classes = useStyles();
  // const theme = useTheme();
  // const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const [mapVersion, setMapVersion] = useState('total');

  return (
    <Grid container direction="column" alignItems="center" className={classes.wrapper}>
      <Grid container direction="column" alignItems="center" className={classes.heading}>
        <Typography variant="body1" className={classes.body1M}>
          In the South, as in the rest of the United States,
          <br /> HIV disproportionately affects people of color.
        </Typography>
        <Typography variant="h2" className={classes.subhead3} style={{ marginTop: '5rem' }}>
          RATES OF PERSONS IN THE US LIVING WITH HIV, 2018
        </Typography>
      </Grid>
      <Grid container justifyContent="center" className={classes.mapButtons}>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          className={classes.buttonCont}
        >
          <Button
            className={mapVersion === 'total' ? classes.buttonContained : classes.buttonOutline}
            onClick={() => {
              setMapVersion('total');
            }}
          >
            TOTAL
          </Button>
          <Button
            className={mapVersion === 'white' ? classes.buttonContained : classes.buttonOutline}
            onClick={() => {
              setMapVersion('white');
            }}
          >
            WHITE
          </Button>
          <Button
            className={mapVersion === 'hispanic' ? classes.buttonContained : classes.buttonOutline}
            onClick={() => {
              setMapVersion('hispanic');
            }}
          >
            HISPANIC
          </Button>
          <Button
            className={mapVersion === 'black' ? classes.buttonContained : classes.buttonOutline}
            onClick={() => {
              setMapVersion('black');
            }}
          >
            BLACK
          </Button>
        </Grid>
      </Grid>
      <Grid container alignItems="center" justifyContent="center" className={classes.mapCont}>
        <Grid container className={classes.map}>
          <img
            src={
              mapVersion === 'black'
                ? mapBlack
                : mapVersion === 'hispanic'
                ? mapHispanic
                : mapVersion === 'white'
                ? mapWhite
                : populationMap
            }
            alt="map of us displaying aids population"
            style={{ width: '100%' }}
          />
        </Grid>

        <Grid container direction="column" alignItems="center" className={classes.sourceCont}>
          <Grid item className={classes.legend}>
            <img src={mapLegend} alt="legend for map" style={{ width: '100%' }} />
          </Grid>
          <Grid item className={classes.source}>
            <Typography className={classes.caption}>
              <a
                href="https://map.aidsvu.org/map"
                target="_blank"
                rel="sponsored"
                className={classes.link}
              >
                Source: AIDSVu.org
              </a>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MapStat2;
